import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/main.css'
import globalMixin from '@/mixins/globalMixins';
//src\mixins\globalMixins.js


import OtpInput from "@bachdgvn/vue-otp-input";

Vue.component("v-otp-input", OtpInput);






Vue.mixin(globalMixin);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
